import { type ComponentProps } from 'react';

import { cn } from '@/lib/utils/cn';

import { fieldControlClassName } from './field-styles';

export function Input({ className, type = 'text', ...props }: ComponentProps<'input'>) {
  return <input type={type} className={cn(fieldControlClassName, 'h-9', className)} {...props} />;
}
